import { render, staticRenderFns } from "./BaseTable.vue?vue&type=template&id=0e4d808a&scoped=true&"
import script from "./BaseTable.vue?vue&type=script&lang=js&"
export * from "./BaseTable.vue?vue&type=script&lang=js&"
import style0 from "./BaseTable.vue?vue&type=style&index=0&id=0e4d808a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4d808a",
  null
  
)

export default component.exports